module.exports = __webpack_public_path__ + "img/calculator-simple.4027bcd7.svg";